export enum EfahrerOrderMDetailActionEnum {
  DOWNLOAD = "download",
  CREATE_THG = "create_thg"
}
